import {
  Box,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useBreakpointValue,
  Flex,
  Text,
  SimpleGrid,
  VStack,
  HStack,
  Button,
  Icon,
  Heading,
  Tag,
  WrapItem,
  Wrap,
  Thead,
  Table,
  Th,
  Tr,
  Tbody,
  Td,
  Modal,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalOverlay,
  Input,
  Textarea,
  ModalFooter,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  CheckboxGroup,
  Stack,
  Checkbox,
  Container,
  Divider,
  Tooltip,
  IconButton,
  Badge,
} from "@chakra-ui/react";
import { PrivateNavbar } from "../../components/layout/PrivateNavbar";
import { ChatDrawer } from "../../components/chat/ChatDrawer";
import { ChatNavbar } from "../../components/chat/ChatNavbar";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { userAPI } from "services/user-api";
import { useChatStore } from "stores/chatStore";
import { ChatSessionType, Character, AIModel } from "types";
import {
  FaComments,
  FaUser,
  FaRobot,
  FaUsers,
  FaCreditCard,
  FaDollarSign,
  FaDiscord,
  FaUserSecret,
  FaCubes,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  FiColumns,
  FiCopy,
  FiCreditCard,
  FiDollarSign,
  FiEdit,
  FiEye,
  FiFileText,
  FiGrid,
  FiLifeBuoy,
  FiList,
  FiMail,
  FiMessageSquare,
  FiPhoneCall,
  FiPlus,
  FiSettings,
  FiTrash,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { Agent } from "types";
import { agentsAPI } from "services/agents-api";
import { charactersAPI } from "services/characters-api";
import { aiAPI } from "services";
import { Footer } from "components/layout/Footer";
interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export const Characters = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenNewCharacter, setIsOpenNewCharacter] =
    React.useState<boolean>(false);
  const [credits, setCredits] = React.useState<number>(0);
  const [characters, setCharacters] = React.useState<Character[]>([]);

  const navigate = useNavigate();
  const {
    currentSession,
    sessions,
    loadSessions,
    createSession,
    deleteSession,
    updateSessionName,
  } = useChatStore();
  const { colorMode } = useColorMode();
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const [editingSessionId, setEditingSessionId] = React.useState<string | null>(
    null
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [sessionNameInput, setSessionNameInput] = React.useState<string>("");
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const [newCharacterName, setNewCharacterName] = React.useState<string>("");
  const [newCharacterDescription, setNewCharacterDescription] =
    React.useState<string>("");
  const [newCharacterModel, setNewCharacterModel] = React.useState<string>("");
  const [newCharacterTemperature, setNewCharacterTemperature] =
    React.useState<number>(0.5);
  const [newCharacterSystemPrompt, setNewCharacterSystemPrompt] =
    React.useState<string>("");
  const [newCharacterTagline, setNewCharacterTagline] =
    React.useState<string>("");
  const [newCharacterGreeting, setNewCharacterGreeting] =
    React.useState<string>("");
  const [newCharacterVoiceId, setNewCharacterVoiceId] =
    React.useState<string>("");
  const [newCharacterKnowledgeFileId, setNewCharacterKnowledgeFileId] =
    React.useState<string>("");
  const [newCharacterPublic, setNewCharacterPublic] =
    React.useState<boolean>(false);
  const [arariaModels, setArariaModels] = React.useState<AIModel[]>([]);

  const loadArariaModels = async () => {
    const arariaModels = await aiAPI.getModels();
    // filter models by capabilities (have to have chat and llm)
    const filteredModels = arariaModels.filter(
      (model) =>
        model.capabilities?.includes("chat") &&
        model.capabilities?.includes("tool-calling") &&
        (model.id?.includes("claude") ||
          model.id?.includes("gemini") ||
          model.id?.includes("gpt")) &&
        model.type === "llm"
    );
    setArariaModels(filteredModels);
  };

  const loadCharacters = async () => {
    try {
      const characters = await charactersAPI.getCharacters(page, limit);
      setCharacters(characters.characters);
      setTotalPages(characters.pagination.pages);
    } catch (error) {
      setError(t("agents.error"));
      console.error("Error loading agents:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const loadUserData = async () => {
    try {
      const userData = await userAPI.getCurrentUser();
      setCredits(Number(userData.credits));
    } catch (error) {
      console.error("Error loading user data:", error);
    }
  };
  useEffect(() => {
    loadCharacters();
    loadUserData();
    loadArariaModels();
  }, []);

  useEffect(() => {
    loadCharacters();
  }, [page]);

  const handleSelectSession = async (selectedSessionId: string) => {
    await navigate(`/chat/${selectedSessionId}`);
  };
  const handleStartRename = (
    session: { id: string; sessionName?: string },
    e: React.MouseEvent
  ) => {
    e.stopPropagation();
    setEditingSessionId(session.id);
    setSessionNameInput(session.sessionName || "");
  };
  const handleRename = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editingSessionId && sessionNameInput.trim()) {
      await updateSessionName(editingSessionId, sessionNameInput.trim());
      setEditingSessionId(null);
      setSessionNameInput("");
    }
  };
  const handleDeleteSession = async (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    await deleteSession(id);
  };
  const handleNewChat = async (
    sessionType: ChatSessionType = ChatSessionType.STANDARD
  ) => {
    const session = await createSession(sessionType);
    if (session) {
      navigate(`/chat/${session.id}`);
    }
    loadSessions();
  };

  const handleNewCharacter = async () => {
    setIsLoading(true);
    const character = await charactersAPI.createCharacter({
      name: newCharacterName,
      modelName: newCharacterModel,
      temperature: newCharacterTemperature,
      description: newCharacterDescription,
      systemPrompt: newCharacterSystemPrompt,
      ...(newCharacterTagline && { tagline: newCharacterTagline }),
      ...(newCharacterGreeting && { greeting: newCharacterGreeting }),
      ...(newCharacterVoiceId && { voiceId: newCharacterVoiceId }),
      ...(newCharacterKnowledgeFileId && {
        knowledgeFileId: newCharacterKnowledgeFileId,
      }),
      ...(newCharacterPublic && { public: newCharacterPublic }),
    });
    if (character) {
      setIsOpenNewCharacter(false);
      loadCharacters();
    }
    setIsLoading(false);
  };
  const handleDeleteCharacter = async (id: string) => {
    await charactersAPI.deleteCharacter(id);
    loadCharacters();
  };
  return (
    <Box h="100vh" display="flex" flexDirection="column">
      <ChatNavbar
        onOpen={onOpen}
        navigate={navigate}
        credits={credits}
        colorMode={colorMode}
        borderColor={borderColor}
      />
      <ChatDrawer
        isOpen={isOpen}
        onClose={onClose}
        sessions={sessions}
        handleNewChat={handleNewChat}
        handleSelectSession={handleSelectSession}
        handleRename={handleRename}
        handleDeleteSession={handleDeleteSession}
        editingSessionId={editingSessionId}
        sessionNameInput={sessionNameInput}
        setSessionNameInput={setSessionNameInput}
        useColorModeValue={useColorModeValue}
        setEditingSessionId={setEditingSessionId}
        handleStartRename={handleStartRename}
        currentSession={currentSession}
      />

      {/* <Box flex="1" bg={bgColor} py={20}> */}
      <Flex flex={1} p={8} align="center" justify="center" bg={bgColor} mt={10}>
        <Container maxW="container.xl">
          <VStack spacing={8} align="stretch">
            <VStack spacing={4} textAlign="center">
              <Heading
                size="2xl"
                fontFamily="Nasalization"
                bgGradient="linear(to-r, brand.primary, brand.secondary)"
                bgClip="text"
              >
                {t("characters.title")}
              </Heading>
              <Text color="gray.500">{t("characters.subtitle")}</Text>
            </VStack>

            {/* Characters Section */}
            <VStack spacing={6} bg={cardBg} p={8} borderRadius="xl" shadow="md">
              <HStack w="full" justify="space-between">
                <Heading size="md">{t("characters.title")}</Heading>
                <Button
                  leftIcon={<FiPlus />}
                  colorScheme="brand"
                  onClick={() => setIsOpenNewCharacter(true)}
                >
                  {t("characters.create")}
                </Button>
              </HStack>

              <Divider />

              {/* Characters Table */}
              <Box overflowX="auto" w="100%">
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>{t("characters.table.title")}</Th>
                      <Th>{t("characters.table.description")}</Th>
                      <Th>{t("characters.table.public")}</Th>
                      <Th>{t("characters.table.actions")}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {characters.map((character) => (
                      <Tr key={character.id}>
                        <Td>{character.name}</Td>
                        <Td>{character.description}</Td>
                        <Td>
                          {character.public
                            ? t("characters.table.public")
                            : t("characters.table.private")}
                        </Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label={t("characters.actions.edit")}>
                              <IconButton
                                aria-label="Edit character"
                                icon={<FiEdit />}
                                size="sm"
                                onClick={() =>
                                  navigate(`/characters/${character.id}`)
                                }
                              />
                            </Tooltip>
                            <Tooltip label={t("characters.actions.delete")}>
                              <IconButton
                                aria-label="Delete character"
                                icon={<FiTrash />}
                                size="sm"
                                onClick={() =>
                                  handleDeleteCharacter(character.id)
                                }
                              />
                            </Tooltip>
                            <Tooltip label={t("characters.actions.chat")}>
                              <IconButton
                                aria-label="Chat with character"
                                icon={<FiMessageSquare />}
                                size="sm"
                                onClick={() =>
                                  navigate(
                                    `/chat/${character.id}?characterId=${character.id}`
                                  )
                                }
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>

              {/* Add pagination controls */}
              <HStack spacing={2} justify="space-between" w="full">
                <Button
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  isDisabled={page === 1}
                >
                  {t("common.previous")}
                </Button>
                <Text>
                  {t("common.page")} {page} / {totalPages}
                </Text>
                <Button
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  isDisabled={page === totalPages}
                >
                  {t("common.next")}
                </Button>
              </HStack>
            </VStack>
          </VStack>
        </Container>
        <Modal
          isOpen={isOpenNewCharacter}
          onClose={() => setIsOpenNewCharacter(false)}
        >
          <ModalOverlay />
          <ModalContent maxW="800px">
            <ModalHeader>{t("characters.newCharacter")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack spacing={4} align="flex-start">
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.name")}
                  </Text>
                  <Input
                    type="text"
                    placeholder={t("characters.name")}
                    value={newCharacterName}
                    onChange={(e) => setNewCharacterName(e.target.value)}
                  />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.model")}
                  </Text>
                  <Select
                    placeholder={t("characters.model")}
                    value={newCharacterModel}
                    onChange={(e) => setNewCharacterModel(e.target.value)}
                  >
                    {arariaModels.map((model) => (
                      <option key={model.id} value={model.id}>
                        {model.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.temperature")}
                  </Text>
                  <NumberInput
                    value={newCharacterTemperature}
                    min={0}
                    max={1}
                    step={0.1}
                    width="100%"
                    onChange={(valueString) => {
                      const value = parseFloat(valueString);
                      if (!isNaN(value) && value >= 0 && value <= 1) {
                        setNewCharacterTemperature(value);
                      } else {
                        setNewCharacterTemperature(0.5);
                      }
                    }}
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.description")}
                  </Text>
                  <Textarea
                    placeholder={t("characters.description")}
                    value={newCharacterDescription}
                    onChange={(e) => setNewCharacterDescription(e.target.value)}
                  />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.systemPrompt")}
                  </Text>
                  <Textarea
                    placeholder={t("characters.systemPrompt")}
                    value={newCharacterSystemPrompt}
                    onChange={(e) =>
                      setNewCharacterSystemPrompt(e.target.value)
                    }
                  />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.tagline")}
                  </Text>
                  <Input type="text" placeholder={t("characters.tagline")} />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.greeting")}
                  </Text>
                  <Input type="text" placeholder={t("characters.greeting")} />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.profilePicture")}
                  </Text>
                  <Input
                    type="text"
                    placeholder={t("characters.profilePicture")}
                  />
                </Box>
                <Box w="full">
                  <Text fontSize="sm" color="gray.500">
                    {t("characters.public")}
                  </Text>
                  <Checkbox
                    isChecked={newCharacterPublic}
                    onChange={(e) => setNewCharacterPublic(e.target.checked)}
                  />
                </Box>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button onClick={handleNewCharacter}>
                {t("characters.create")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>
      <Footer />
    </Box>
  );
};
